<template>
    <div id="LPersonal">
        <div class="LBanner LWidth">
            <img src="../../../assets/img/index/21.png" alt="" />
        </div>
        <!--  -->
        <div class="LWidth">
            <div class="Lbread">
                <Breadcrumb separator=">">
                    <BreadcrumbItem to="/index">首页</BreadcrumbItem>
                    <BreadcrumbItem>账号中心</BreadcrumbItem>
                    <BreadcrumbItem>账号信息</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="lConter">
                <!-- 左侧 -->
                <div class="lConterLeft">
                    <div class="lLfetTitle">
                        <div class="ltitleImg">
                            <img
                                src="../../../assets/img/common/q1.png"
                                alt=""
                                class="hello"
                            />
                        </div>
                        <p class="lTile">账号中心</p>
                    </div>
                    <div  class="LMenu">
                        <ul style="list-style:none">
                            <li v-for="(item,i) in menu" :key="i" >
                                <div  v-if="item.title !== '我的课程' && type == 1 && item.title !== '学时管理' && type == 1 && item.title !== '证书管理' && type == 1 || type !== 0">
                                    <div class="oneMenu" @click="oneMenuClick(item)">
                                        <div class="oneMenuLeft" :class="{oneMenuLeftAtiv:item.title==oneMenu}"></div>
                                        <div>
                                            <Badge dot :count="item.count">
                                                <router-link class="oneMenuText" :class="{oneMenuTextAtiv:item.title==oneMenu}"  :to="item.to">{{item.title}}</router-link>
                                            </Badge>
                                        </div>
                                    </div>
                                    <ul class="towMenu" :class="{towMenuBlock:item.title==oneMenu}">
                                        <li v-for="(res,index) in item.children" :key="index" >
                                            <span @click="towMenuClick(res.title)" >
                                            <router-link class="routa" ref="routa" :class="{towMenuA:res.title==twoMenu}"  :to="res.to">{{res.title}}</router-link>
                                            </span>
                                        </li>
                                        <!-- <li><a href="#">快递地址</a></li>
                                        <li><a href="#">发票抬头</a></li> -->
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 右侧 -->
                <div class="lConterRight">
                    
                    <!-- 右侧的视图核心 -->
                    <router-view @editPage="editPage"></router-view>

                    <!-- 个人信息 -->
                    <!-- <News/> -->
                    <!-- 地址 -->
                    <!-- <Address/> -->
                    <!-- 发票 -->
                    <!-- <Invoice/> -->
                    <!-- 证书 -->
                    <!-- <Certificate/> -->
                    <!-- 修改密码 -->
                    <!-- <ChangePassword/> -->
                    <!-- 我的培训项目 -->
                    <!-- <MyMTraining/> -->
                    <!-- 通知管理 -->
                    <!-- <Notice/> -->
                    <!-- 订单管理 -->
                    <!-- <Order /> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import News from "./news";
import Address from "./address";
import Invoice from "./invoice";
import Certificate from "./certificate";
import ChangePassword from "./changePassword";
import MyMTraining from "./myTraining";
import Notice from "./notice";
import Order from "./order";
import Invoicemanagement from "./Invoicemanagement";
import Courier from "./Courier";
import Cookies from "js-cookie";

import {findUnReadByUserId, findGustBookUnRead} from '../../../network/profile'

export default {
    components: {
        News,
        Address,
        Invoice,
        Certificate,
        ChangePassword,
        MyMTraining,
        Notice,
        Order,
        Invoicemanagement,
        Courier,
    },
    name:'LPersonal',
    data() {
        return {
            menu:[
                {
                    title:'账户资料',
                    count: 0,
                    to:'',
                    children:[
                        {title:'基本信息',to:"/news"},
                        {title:'快递地址',to:"/address"},
                        {title:'发票抬头',to:"/invoice"},
                    ]
                },
                {
                    title:'密码修改', 
                    count: 0,
                    to:'/changePassword',
                    children:[]
                },
                {
                    title:'我的课程',
                    count: 0,
                    to:"/myTraining",
                    children:[]
                },
                {
                    title:'订单管理',
                    count: 0,
                    to:"/order",
                    children:[]
                },
               
                {
                    title:'学时管理',
                    count: 0,
                    to:"",
                    children:[
                        {title:"学时查询",to:"/xueshiguanli"},
                        {title:"二类专业学时",to:"/Twoperiod"}
                    ]
                },
                {
                    title:'发票查询',
                    to:"/Invoicemanagement",
                    count: 0,
                    children:[]
                },
                
                {
                    title:'快递查询',
                    count: 0,
                    to:"/Courier",
                    children:[]
                },
                {
                    title:'证书管理',
                    count: 0,
                    to:"/certificate",
                    children:[]
                },
                 {
                    title:'教材征订',
                    count: 0,
                    to:"/teachingBookPage3",
                    children:[]
                },
                {
                    title:'咨询留言',
                    count: 0,
                    to:"/messageBox",
                    children:[]
                },
                {
                    title:'站内消息',
                    count: 0,
                    to:"/notice",
                    children:[]
                },
            ],
            oneMenu:'账户资料',
            twoMenu:'个人信息',
            type: null,
            isMessage: 0,
            isStation: 0,
        };
    },
    activated(){
        this.type = this.Get('type')
        //站内通知
        findUnReadByUserId()
        .then(r => {
            console.log(r,'rrrrrrrrrrrrrrrr');
            this.menu[10].count = r.data.data;
            this.$forceUpdate();
        })
        findGustBookUnRead()
        .then(r => {
            console.log(r,'rrrrrrrrrrrrrrrr');
            this.menu[9].count = r.data.data;
        })

        if(this.type==1){
            this.menu=[
                {
                    title:'账户资料',
                    to:'',
                    count: 0,
                    children:[
                        {title:'基本信息',to:"/news"},
                        {title:'快递地址',to:"/address"},
                        {title:'发票抬头',to:"/invoice"},
                    ]
                },
                {
                    title:'密码修改', 
                    count: 0,
                    to:'/changePassword',
                    children:[]
                },
                {
                    title:'订单管理',
                    count: 0,
                    to:"/order",
                    children:[]
                },
                {
                    title:'发票查询',
                    count: 0,
                    to:"/Invoicemanagement",
                    children:[]
                },
                
                {
                    title:'快递查询',
                    count: 0,
                    to:"/Courier",
                    children:[]
                },
                 {
                    title:'教材征订',
                    count: 0,
                    to:"/teachingBookPage3",
                    children:[]
                },
                {
                    title:'咨询留言',
                    count: 0,
                    to:"/messageBox",
                    children:[]
                },
                {
                    title:'站内消息',
                    count: 0,
                    to:"/notice",
                    children:[]
                },
            ]
        } else{
            this.menu=[
                {
                    title:'账户资料',
                    count: 0,
                    to:'',
                    children:[
                        {title:'基本信息',to:"/news"},
                        {title:'快递地址',to:"/address"},
                        {title:'发票抬头',to:"/invoice"},
                    ]
                },
                {
                    title:'密码修改', 
                    count: 0,
                    to:'/changePassword',
                    children:[]
                },
                {
                    title:'我的课程',
                    count: 0,
                    to:"/myTraining",
                    children:[]
                },
                {
                    title:'订单管理',
                    count: 0,
                    to:"/order",
                    children:[]
                },
               
                {
                    title:'学时管理',
                    count: 0,
                    to:"",
                    children:[
                        {title:"学时查询",to:"/xueshiguanli"},
                        {title:"二类专业学时",to:"/Twoperiod"}
                    ]
                },
                {
                    title:'发票查询',
                    to:"/Invoicemanagement",
                    count: 0,
                    children:[]
                },
                
                {
                    title:'快递查询',
                    to:"/Courier",
                    count: 0,
                    children:[]
                },
                {
                    title:'证书管理',
                    count: 0,
                    to:"/certificate",
                    children:[]
                },
                 {
                    title:'教材征订',
                    count: 0,
                    to:"/teachingBookPage3",
                    children:[]
                },
                {
                    title:'咨询留言',
                    count: 0,
                    to:"/messageBox",
                    children:[]
                },
                {
                    title:'站内消息',
                    count: 0,
                    to:"/notice",
                    children:[]
                },
            ]
        }
    },
    methods: {
        
        Get(name) {
        return Cookies.get(`admin-${name}`);
        },
        editPage(val1, val2) { // 子级更改了页面
            this.oneMenu = val1;
            this.twoMenu = val2;
        },
        // 点击一级菜单
        oneMenuClick(val){
            this.oneMenu=val.title;
           
        },
        towMenuClick(val){
             this.twoMenu=val;
        },
        
    },
};
</script>

<style scoped>
@import url("../../../assets/css/liucss/LPersonal.css");

</style>